customElements.get("dbtfy-cart-discount") ||
  customElements.define(
    "dbtfy-cart-discount",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.data = Debutify.widgets["dbtfy-cart-discount"]),
          this.querySelector(".delivery-label-icon i").setAttribute(
            "data-icon",
            this.data.dbtfy_cart_discount_label_icon
          ),
          (this.discountSummaryLabel = this.querySelector(
            ".dbtfy-cart-discount-show"
          )),
          (this.discountStatus = this.querySelector(".discount-status")),
          (this.discountCode = ""),
          (this.button = this.querySelector(".dbtfy-cart-discount__button")),
          (this.modalHeader = this.querySelector(
            ".dbtfy-discount-modal--header"
          )),
          (this.relaceText = this.dataset.relaceText),
          (this.fetch = !1),
          this.setup();
      }
      setup() {
        void 0 !== Debutify.modal
          ? this.loadModel()
          : document.addEventListener("DOMContentLoaded", () => {
              this.loadModel();
            }),
          this.init(),
          this.fetchCart("");
      }
      init() {
        this.button &&
          (this.button.onclick = () => {
            const t = this.querySelector("input").value;
            "" !== t &&
              ((this.discountCode = t),
              this.checkExistingDiscountAndApply(t),
              (this.fetch = !0));
          });
      }
      loadModel() {
        (this.modalHeader.textContent = this.relaceText),
          (this.modal = new Debutify.modal({
            closeMethods: [],
            size: "medium",
            closeIcon: "",
            selector: "dbtfy-discount-modal",
            boxClass: ["dbtfy-discount-box"],
            overlayClass: ["dbtfy-discount-overlay"],
            onOpen: function () {},
            onClose: function () {},
          }));
      }
      drawerUpdate() {
        localStorage.setItem("dbtfy-cart-discount", this.discountCode),
          fetch(`${routes.cart_url}?section_id=${Debutify.cart_drawer_id}`)
            .then((t) => t.text())
            .then((t) => {
              if (
                document.querySelector(
                  "#shopify-section-" + Debutify.cart_drawer_id + " #CartDrawer"
                )
              ) {
                const e = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(
                    "#shopify-section-" +
                      Debutify.cart_drawer_id +
                      " #CartDrawer"
                  );
                document
                  .querySelector(
                    "#shopify-section-" +
                      Debutify.cart_drawer_id +
                      " #CartDrawer"
                  )
                  .replaceWith(e);
              }
              const e = document.querySelector("cart-details");
              e && e.updateSection(t);
            })
            .catch((t) => {
              console.error(t);
            });
      }
      applyDiscount(t) {
        fetch(`/discount/${t}`, {
          method: "GET",
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
          .then((t) => {
            t.ok || console.error("Failed to apply discount: " + t.statusText);
          })
          .catch((t) => {
            console.error("Error applying discount:", t);
          })
          .finally(() => {
            localStorage.setItem("dbtfy-cart-discount", t), this.drawerUpdate();
          });
      }
      checkExistingDiscountAndApply(t) {
        const e = document.querySelector(".discounts__discount");
        e && "" === e.textContent.trim()
          ? this.applyDiscount(t)
          : this.fetchCart(t);
      }
      fetchCart(t) {
        fetch(`${window.routes.cart_url}.js`)
          .then((t) => t.json())
          .then((e) => {
            let o = !1;
            this.cartItemsDiscount = e.items;
            let s = "";
            this.cartItemsDiscount.forEach((t) => {
              t.discounts.length > 0 &&
                ((o = !0),
                (s = t.discounts[0].title),
                (this.discountSummaryLabel.textContent = s));
            }),
              t && (s = t),
              document
                .querySelectorAll(
                  '.dbtfy-cart-discount__container input[type="text"]'
                )
                .forEach((t) => {
                  t.value = s;
                }),
              o
                ? this.fetch &&
                  (this.modal.modal
                    .querySelectorAll(
                      ".dbtfy-discount-modal-check-yes-no button"
                    )
                    .forEach((t) => {
                      t.onclick = () => {
                        "yes" === t.value
                          ? (this.modal.close(), this.applyDiscount(s))
                          : this.modal.close();
                      };
                    }),
                  this.modal.open())
                : this.fetch && this.applyDiscount(s),
              localStorage.getItem("dbtfy-cart-discount") &&
                (this.discountStatus.classList.remove("hidden"),
                localStorage.getItem("dbtfy-cart-discount").toLowerCase() ==
                this.discountSummaryLabel.textContent.toLowerCase()
                  ? (this.discountStatus.textContent = " Applied")
                  : (this.discountStatus.textContent = " Invalid"),
                setTimeout(() => {
                  localStorage.removeItem("dbtfy-cart-discount");
                }, 500));
          })
          .catch((t) => {
            console.error("Error fetching cart:", t);
          });
      }
    }
  );
